module.exports = __webpack_public_path__ + "img/中国科学院.b30c9f38.png";